import React, { useEffect, useRef, useState } from 'react'
import { checkSession, login, register } from '../../services'
import { useHistory } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { Grid, Box, Menu, MenuItem, Dialog, DialogContent, Button, Link, Snackbar, Fab, IconButton } from '@mui/material';
import Fade from 'react-reveal/Fade';
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
export default function Login() {
    const history = useHistory();
    const [isSignupMode, setisSignupMode] = useState(false)
    const [isRequestLoading, setisRequestLoading] = useState(false)
    const [isRequestSignUp, setisRequestSignUp] = useState(false)
    const [messErr, setmessErr] = useState("")
    const usernameInput = useRef()
    const passwordInput = useRef()
    const fullName = useRef()
    const userSign = useRef()
    const email = useRef()
    const parentName = useRef()
    const DOB = useRef()
    const numberPhone = useRef()
    const passSign = useRef()
    const rePassSign = useRef()
    const province = useRef()
    const [isApax, setisApax] = React.useState(null)
    const [anchorMenuLogin, setanchorMenuLogin] = React.useState(null)
    const [isOpenDialog, setisOpenDialog] = React.useState(null)
    const [messErrSignUp, setErrMessSignUp] = React.useState("");
    const [typeOfDialog, setTypeOfDialog] = React.useState(false);
    const [messSusSignUp, setMessSusSignUp] = React.useState("");

    useEffect(() => {
        const sessionId = localStorage.getItem("sessionId")
        if (sessionId) {
            const data = {
                sessionId
            }
            checkSession(data).then(res => {
                if (res.data.responseCode == 200) history.push("/editor")
            })
        }
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        const user_name = usernameInput.current.value
        const user_pass = passwordInput.current.value
        if (user_name == "" && user_pass == "") setmessErr("Tên đăng nhập và Mật khẩu không được bỏ trống!")
        else if (user_name == "" && user_pass != "") setmessErr("Tên đăng nhập không được bỏ trống!")
        else if (user_name != "" && user_pass == "") setmessErr("Mật khẩu không được bỏ trống!")
        else {
            setisRequestLoading(true)
            const data = {
                user_name,
                user_pass,
            }
            login(data).then(res => {
                setisRequestLoading(false)
                if (res.data.responseCode == 200) {
                    localStorage.setItem("sessionId", res.data.data.sessionId)
                    // document.cookie = "sessionId="+res.data.data.sessionId+"n; expires=Wed, 05 Aug 2020 23:00:00 UTC";
                    history.push("/editor")
                }
                else if (res.data.responseCode == 404) {
                    setmessErr(res.data.data)
                }
                else {
                    setmessErr("Có lỗi xảy ra")
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }

    const handleSignUp = (e) => {
        e.preventDefault()
        const user_parent_name = parentName.current.value
        const user_phone = numberPhone.current.value
        const user_apax_name = fullName.current.value
        const user_birth_year = DOB.current.value
        const user_mail = email.current.value
        const user_name = userSign.current.value
        const user_pass = passSign.current.value
        const retype = rePassSign.current.value
        const user_province = province.current.value
        const regrexVN = /^[a-z A-Z0-9_.-]{1,50}$/
        const regrexSpecialKey = /[ `!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~]/
        let is_apax_user = ""
        if (isApax == true) is_apax_user = "Y"
        else if (isApax == false) is_apax_user = "N"
        setErrMessSignUp("Password nhập lại không đúng")
        if (isApax == null || user_province == "" || user_name == "" || user_pass == "" || retype == "" || user_parent_name == "" || user_apax_name == "" || user_phone == "" || user_birth_year == "") setErrMessSignUp("Vui lòng điền đầy đủ các trường thông tin bắt buộc")
        else if (parseInt(user_birth_year) < 1870 || parseInt(user_birth_year) > 2020) {
            setErrMessSignUp("Năm sinh vừa nhập không đúng")
        }
        else if (user_pass !== retype) {
            setErrMessSignUp("Password nhập lại không đúng")
        }

        else if (!regrexVN.test(user_name)) {
            setErrMessSignUp("Username không được chứa các ký tự đặc biệt")
        }
        else if (regrexSpecialKey.test(user_name)) {
            setErrMessSignUp("Username không được chứa các ký tự đặc biệt")
        }
        // else if()
        else {
            setisRequestSignUp(true)
            const data = {
                user_name,
                user_pass,
                user_mail,
                user_parent_name,
                user_apax_name,
                user_phone,
                user_province,
                user_birth_year,
                is_apax_user,
            }
            register(data).then(res => {
                setisRequestSignUp(false)
                if (res.data.responseCode == 200) {
                    setErrMessSignUp("")
                    setMessSusSignUp("Đăng ký thành công")
                    localStorage.setItem("sessionId", res.data.data.sessionId)
                    setTimeout(() => {
                        history.push("/editor")
                    }, 1000)
                }
                else if (res.data.responseCode == 404) {
                    setErrMessSignUp(res.data.data)
                }
                else {
                    setMessSusSignUp("Có lỗi xảy ra")
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }

    const handleOpenDiaglog = (val) => {
        setTypeOfDialog(val)
        setisOpenDialog(true)
        setanchorMenuLogin(null)
    }
    return (

        <div className="login-container" >
            <h2 className="hastag-desktop">#ApaxGreatestTeachers</h2>
            <Box sx={{ flexGrow: 1 }} ml={2} mr={2} style={{ minHeight: "100%" }}>
                <Grid container >
                    <Grid item md={8}>
                    </Grid>
                    <Grid item md={4} xs={12} style={{ minHeight: "100vh" }}>
                        <div className="left-panel">

                            <div className="logo-container" >
                                <img src="/img/logo.png" style={{ width: "40%" }} alt="" />
                            </div>
                            <div className="forms-container-login">
                                <div className="signin-signup">
                                    {!isSignupMode ?
                                        <form className="sign-in-form login-form" onSubmit={handleSubmit}>

                                            <h2 className="login-title">THAM GIA MIỄN PHÍ</h2>
                                            <div className="input-container">
                                                <div className="input-field">
                                                    <input className="input-form" type="text" placeholder="Username" ref={usernameInput} />
                                                </div>
                                            </div>
                                            <div className="input-container">
                                                <div className="input-field">
                                                    <input className="input-form" type="password" placeholder="Password" ref={passwordInput} />
                                                </div>
                                            </div>
                                            {messErr != "" ?
                                                <h4 className="text-danger" style={{ marginBottom: "0" }}>
                                                    {messErr}
                                                </h4>
                                                : null}
                                            <div>

                                                <Button type="submit" className="btn-login content-middle" variant="contained">
                                                    {isRequestLoading ?
                                                        <div className="lds-ellipsis"><div></div><div></div><div></div></div> :
                                                        <span className="login-btn-text">Đăng nhập / Sign in</span>
                                                    }
                                                </Button>
                                            </div>
                                            <div>

                                            </div>
                                            <span style={{ fontStyle: "italic" }}>Nếu chưa có tài khoản</span>
                                            <div className="btn-signup-change">
                                                <Button onClick={() => setisSignupMode(true)} className="btn-login content-middle " variant="contained">
                                                    <span style={{ fontWeight: "bold" }}>Đăng ký / Sign up</span>
                                                </Button>
                                            </div>
                                        </form>
                                        :
                                        <form className="sign-up-form login-form" onSubmit={handleSignUp} autoComplete="off">
                                            <h2 className="login-title">Thông tin đăng ký</h2>
                                            <input name="username" type="username" style={{ display: "none" }} autocomplete="on" />
                                            <input name="password" type="password" style={{ display: "none" }} autocomplete="on" />
                                            <p style={{ width: "85%", textAlign: "right", margin: "0 auto " }}>* Bắt buộc</p>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && parentName.current.value == "" ? "input-err" : ""} type="text" placeholder="Họ tên phụ huynh/Parent's name*" ref={parentName} />
                                                </div>
                                            </div>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && numberPhone.current.value == "" ? "input-err" : ""} type="number" placeholder="Số điện thoại/ Phone number*" ref={numberPhone} />
                                                </div>
                                            </div>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && fullName.current.value == "" ? "input-err" : ""} type="text" placeholder="Họ và tên học sinh/ Student's name*" ref={fullName} />
                                                </div>
                                            </div>

                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && DOB.current.value == "" ? "input-err" : ""} type="number" placeholder="Năm sinh/ Year of birth*" ref={DOB} />
                                                </div>
                                            </div>

                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input type="email" placeholder="Email" ref={email} />
                                                </div>
                                            </div>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && userSign.current.value == "" ? "input-err" : ""} type="text" placeholder="Tên đăng nhập/ Username*" ref={userSign} />
                                                </div>
                                            </div>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && passSign.current.value == "" ? "input-err" : ""} type="password" placeholder="Mật khẩu/ Password*" ref={passSign} />
                                                </div>
                                            </div>
                                            <div className="input-signup-container">
                                                <div className="input-field">
                                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && rePassSign.current.value == "" ? "input-err" : ""} type="password" placeholder="Nhập lại mật khẩu/ Confirm password*" ref={rePassSign} />
                                                </div>
                                            </div>
                                            <Fade bottom when={isApax != null} collapse>
                                                <div className="input-signup-container">
                                                    <div className="input-field">
                                                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && province.current.value == "" ? "input-err" : ""} type="text" placeholder={isApax ? "Tên trung tâm/ Center*" : "Tên tỉnh, TP/ City*"} ref={province} />
                                                    </div>
                                                </div>
                                            </Fade>

                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", marginTop: "1em" }}>
                                                <h5 style={{ fontSize: "1.1em", margin: "0", fontStyle: "italic", fontWeight: "normal" }} >Bạn là học sinh Apax?/Are you Apaxer?*</h5>
                                            </div>
                                            <div>
                                                <div className="checkbox-container" style={{ display: "inline-block" }}>
                                                    <Checkbox
                                                        checked={isApax == true}
                                                        onChange={() => setisApax(true)}
                                                    />
                                                    <span>Đúng/Yes</span>

                                                </div>
                                                <div checkbox-container style={{ display: "inline-block", marginLeft: "1em " }}>

                                                    <Checkbox
                                                        checked={isApax == false}
                                                        onChange={() => setisApax(false)}
                                                    />
                                                    <span>Chưa/No</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div>

                                                    <Button type="submit" className="btn-signup content-middle" variant="contained">
                                                        {isRequestSignUp ?
                                                            <div className="lds-ellipsis"><div></div><div></div><div></div></div> :
                                                            <span className="login-btn-text">ĐĂNG KÝ / SIGN UP</span>
                                                        }
                                                    </Button>

                                                </div>
                                                <div style={{ paddingBottom: "1em" }}>
                                                    <Link onClick={() => setisSignupMode(false)} >Đã có tài khoản?</Link>
                                                </div>
                                            </div>
                                        </form>
                                    }
                                </div>
                            </div>
                            <Fab size="medium" className="float-login-btn" onClick={(e) => setanchorMenuLogin(e.currentTarget)}>
                                <FontAwesomeIcon icon={faUser} style={{ fontSize: "1.45em" }} />
                            </Fab>
                            <div className="contact-container">
                                <p>Hotline: 1900 63 3979
                                </p>
                                <p>
                                    Email: marketing@apaxleaders.edu.vn
                                </p>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: "left" }} open={messErrSignUp != ""} onClose={() => setErrMessSignUp("")}>
                <Alert onClose={() => setErrMessSignUp("")} severity="error" sx={{ width: '100%' }}>
                    {messErrSignUp}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: "left" }} open={messSusSignUp != ""} onClose={() => setMessSusSignUp("")}>
                <Alert onClose={() => setMessSusSignUp("")} severity="success" sx={{ width: '100%' }}>
                    {messSusSignUp}
                </Alert>
            </Snackbar>
            <Menu

                anchorEl={anchorMenuLogin}
                open={Boolean(anchorMenuLogin)}
                onClose={() => setanchorMenuLogin(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => handleOpenDiaglog('signin')}>Đăng nhập</MenuItem>
                <MenuItem onClick={() => handleOpenDiaglog('signup')}>Đăng ký</MenuItem>
            </Menu>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={isOpenDialog}>

                <DialogContent style={{ paddingBottom: "10px", backgroundColor: "#ffda73", position: "relative" }}>
                    {typeOfDialog == "signin" ?
                        <form className="sign-in-form login-form" onSubmit={handleSubmit}>
                            <IconButton className="close-dialog-btn" onClick={() => setisOpenDialog(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>
                            <h2 className="login-title">THAM GIA MIỄN PHÍ</h2>
                            <div className="input-container">
                                <div className="input-field">
                                    <input className="input-form" type="text" placeholder="Username" ref={usernameInput} />
                                </div>
                            </div>
                            <div className="input-container">
                                <div className="input-field">
                                    <input className="input-form" type="password" placeholder="Password" ref={passwordInput} />
                                </div>
                            </div>
                            {messErr != "" ?
                                <h4 className="text-danger" style={{ marginBottom: "0" }}>
                                    {messErr}
                                </h4>
                                : null}
                            <div>

                                <Button type="submit" className="btn-login content-middle" variant="contained">
                                    {isRequestLoading ?
                                        <div className="lds-ellipsis"><div></div><div></div><div></div></div> :
                                        <span className="login-btn-text">Đăng nhập / Sign in</span>
                                    }
                                </Button>
                            </div>
                            <div>

                            </div>

                        </form> : <form className="sign-up-form login-form" onSubmit={handleSignUp} autoComplete='off'>
                            <IconButton className="close-dialog-btn" onClick={() => setisOpenDialog(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>
                            <input name="username" type="username" style={{ display: "none" }} autocomplete="on" />
                            <input name="password" type="password" style={{ display: "none" }} autocomplete="on" />
                            <h2 className="login-title">Thông tin đăng ký</h2>
                            <p style={{ width: "85%", textAlign: "right", margin: "0 auto " }}>* Bắt buộc</p>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && parentName.current.value == "" ? "input-err" : ""} type="text" placeholder="Họ tên phụ huynh/Parent's name*" ref={parentName} />
                                </div>
                            </div>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && numberPhone.current.value == "" ? "input-err" : ""} type="number" placeholder="Số điện thoại/ Phone number*" ref={numberPhone} />
                                </div>
                            </div>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && fullName.current.value == "" ? "input-err" : ""} type="text" placeholder="Họ và tên học sinh/ Student's name*" ref={fullName} />
                                </div>
                            </div>

                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && DOB.current.value == "" ? "input-err" : ""} type="number" placeholder="Năm sinh/ Year of birth*" ref={DOB} />
                                </div>
                            </div>

                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input type="email" placeholder="Email" ref={email} />
                                </div>
                            </div>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && userSign.current.value == "" ? "input-err" : ""} type="text" placeholder="Tên đăng nhập/ Username*" ref={userSign} />
                                </div>
                            </div>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && passSign.current.value == "" ? "input-err" : ""} type="password" placeholder="Mật khẩu/ Password*" ref={passSign} />
                                </div>
                            </div>
                            <div className="input-signup-container">
                                <div className="input-field">
                                    <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && rePassSign.current.value == "" ? "input-err" : ""} type="password" placeholder="Nhập lại mật khẩu/ Confirm password*" ref={rePassSign} />
                                </div>
                            </div>
                            <Fade bottom when={isApax != null} collapse>
                                <div className="input-signup-container">
                                    <div className="input-field">
                                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && province.current.value == "" ? "input-err" : ""} type="text" placeholder={isApax ? "Tên trung tâm/ Center*" : "Tên tỉnh, TP/ City*"} ref={province} />
                                    </div>
                                </div>
                            </Fade>

                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", marginTop: "1em" }}>
                                <h5 style={{ fontSize: "1.1em", margin: "0", fontStyle: "italic", fontWeight: "normal" }} >Bạn là học sinh Apax?/Are you Apaxer?*</h5>
                            </div>
                            <div>
                                <div className="checkbox-container" style={{ display: "inline-block" }}>
                                    <Checkbox
                                        checked={isApax == true}
                                        onChange={() => setisApax(true)}
                                    />
                                    <span>Đúng/Yes</span>

                                </div>
                                <div checkbox-container style={{ display: "inline-block", marginLeft: "1em " }}>

                                    <Checkbox
                                        checked={isApax == false}
                                        onChange={() => setisApax(false)}
                                    />
                                    <span>Chưa/No</span>
                                </div>
                            </div>
                            <div>
                                <div>

                                    <Button type="submit" className="btn-signup content-middle" variant="contained">
                                        {isRequestSignUp ?
                                            <div className="lds-ellipsis"><div></div><div></div><div></div></div> :
                                            <span className="login-btn-text">ĐĂNG KÝ / SIGN UP</span>
                                        }
                                    </Button>

                                </div>

                            </div>
                        </form>}
                </DialogContent>
            </Dialog>
        </div>


    )
}
